export default {
  en: {
    externalId: 'External ID',
    integrationId: 'Integration ID',
    firstname: 'First Name',
    lastname: 'Last Name',
    email: 'Email',
    phone: 'Phone',
    documentId: 'Document ID',
    addressLine: 'Address',
    country: 'Country',
    city: 'City',
    state: 'State/Province',
    postalCode: 'Postal Code',
    birthDate: 'Birth Date',
    gender: 'Gender',
    maritalStatus: 'Marital Status',
    currency: 'Currency',
    lastPurchaseDate: 'Last Purchase Date',
    loyaltyStatus: 'Loyalty Status',
    paymentPreference: 'Payment Preference',
    preferredLanguage: 'Preferred Language',
    contactPreference: 'Contact Preference',
    leadSource: 'Lead Source',
    campaignSource: 'Campaign Source',
    campaignId: 'Campaign ID',
    campaignMedium: 'Campaign Medium',
    campaignContent: 'Campaign Content',
    leadStatus: 'Lead Status',
    lifecycleStage: 'Lifecycle Stage',
    companyName: 'Company Name',
    companyId: 'Company ID',
    industry: 'Industry',
    website: 'Website',
    parentCompanyName: 'Parent Company Name',
    ownershipType: 'Ownership Type',
    partnershipStatus: 'Partnership Status',
    expectedCloseDate: 'Expected Close Date',
    retentionPolicyDate: 'Retention Policy Date',
    companyEmail: 'Company Email',
    systemId: 'System ID',
    secondaryEmail: 'Secondary Email',
    username: 'Username',
    taxId: 'Tax/VAT ID',
    legalId: 'Legal ID',
    primaryAssignment: 'Primary contact',
    secondaryAssignment: 'Secondary contact',
    supportAssignment: 'Support contact',
    lastContactAt: 'Last Contact At',
    createdAt: 'Created At',
    fullName: 'Name',
    assignments: 'Assignments',
    undefined: 'No data',
    primaryContact: 'Primary contact',
    contacts: 'Contacts',
  },
  es: {
    externalId: 'ID Externo',
    integrationId: 'ID de Integración',
    firstname: 'Nombre',
    lastname: 'Apellido',
    email: 'Email',
    phone: 'Teléfono',
    documentId: 'ID de Documento',
    addressLine: 'Dirección',
    country: 'País',
    city: 'Ciudad',
    state: 'Estado/Provincia',
    postalCode: 'Código Postal',
    birthDate: 'Fecha de Nacimiento',
    gender: 'Género',
    maritalStatus: 'Estado Civil',
    currency: 'Moneda',
    lastPurchaseDate: 'Fecha de Última Compra',
    loyaltyStatus: 'Estado de Fidelidad',
    paymentPreference: 'Preferencia de Pago',
    preferredLanguage: 'Idioma Preferido',
    contactPreference: 'Preferencia de Contacto',
    leadSource: 'Origen del Lead',
    campaignSource: 'Origen de Campaña',
    campaignId: 'ID de Campaña',
    campaignMedium: 'Medio de Campaña',
    campaignContent: 'Contenido de Campaña',
    leadStatus: 'Estado del Lead',
    lifecycleStage: 'Etapa del Ciclo de Vida',
    companyName: 'Nombre Empresa',
    companyId: 'ID Empresa',
    industry: 'Industria',
    website: 'Sitio Web',
    parentCompanyName: 'Nombre Casa Matriz',
    ownershipType: 'Tipo de Propiedad',
    partnershipStatus: 'Estado de Asociación',
    expectedCloseDate: 'Fecha Estimada de Cierre',
    retentionPolicyDate: 'Fecha Política de Retención',
    companyEmail: 'Email de Empresa',
    systemId: 'ID del Sistema',
    secondaryEmail: 'Email Secundario',
    username: 'Nombre de Usuario',
    taxId: 'ID Fiscal/IVA',
    legalId: 'ID Legal',
    primaryAssignment: 'Contacto Principal',
    secondaryAssignment: 'Contacto Secundario',
    supportAssignment: 'Contacto de Soporte',
    lastContactAt: 'Último Contacto',
    createdAt: 'Creado',
    fullName: 'Nombre',
    assignments: 'Asignaciones',
    undefined: 'Sin datos',
    primaryContact: 'Contacto primario',
    contacts: 'Contactos',
  },
  fr: {
    externalId: 'ID Externe',
    integrationId: 'ID d\'Intégration',
    firstname: 'Prénom',
    lastname: 'Nom',
    email: 'E-mail',
    phone: 'Téléphone',
    documentId: 'ID du Document',
    addressLine: 'Adresse',
    country: 'Pays',
    city: 'Ville',
    state: 'État/Province',
    postalCode: 'Code Postal',
    birthDate: 'Date de Naissance',
    gender: 'Genre',
    maritalStatus: 'État Civil',
    currency: 'Devise',
    lastPurchaseDate: 'Date du Dernier Achat',
    loyaltyStatus: 'Statut de Fidélité',
    paymentPreference: 'Préférence de Paiement',
    preferredLanguage: 'Langue Préférée',
    contactPreference: 'Préférence de Contact',
    leadSource: 'Source du Lead',
    campaignSource: 'Source de la Campagne',
    campaignId: 'ID de Campagne',
    campaignMedium: 'Moyen de Campagne',
    campaignContent: 'Contenu de Campagne',
    leadStatus: 'Statut du Lead',
    lifecycleStage: 'Étape du Cycle de Vie',
    companyName: 'Nom de l\'Entreprise',
    companyId: 'ID de l\'Entreprise',
    industry: 'Industrie',
    website: 'Site Web',
    parentCompanyName: 'Nom de la Société Mère',
    ownershipType: 'Type de Propriété',
    partnershipStatus: 'Statut de Partenariat',
    expectedCloseDate: 'Date de Clôture Prévue',
    retentionPolicyDate: 'Date de Politique de Rétention',
    companyEmail: 'E-mail de l\'Entreprise',
    systemId: 'ID du Système',
    secondaryEmail: 'E-mail Secondaire',
    username: 'Nom d\'Utilisateur',
    taxId: 'ID Fiscal/TVA',
    legalId: 'ID Légal',
    primaryAssignment: 'Contact Principal',
    secondaryAssignment: 'Contact Secondaire',
    supportAssignment: 'Contact de Support',
    lastContactAt: 'Dernier Contact Le',
    createdAt: 'Créé Le',
    fullName: 'Nom',
    assignments: 'Affectations',
    undefined: 'Pas de données',
    primaryContact: 'Contact principal',
    contacts: 'Contacts',
  }
}
